/*

Ashraf 11/27/2022 2698947782 Added data repository reducer functions
Ashraf 11/29/2022 2698947782 fixed download repo data issues
Ashraf 11/30/2022 2698947782 changed url's for usage
Poornima 12/01/2022 2698947782 handled error message when saved
Dilip 12/07/2022 3031450488  added data repository system notes reducer functions
Rajesh 12/09/2022 2692790263 reset issue for download
akhila 12/12/2022 2692790263 changed api for RepositoryFields Usage
Sohel 02/09/2023 2700912712 Fixed page break issue
Akhila 03/01/2023 2698947782 Added loader and download toast message for preview File
Sohel 03/10/2023 2698947782 Fixed page break issue
Ravi 06/22/2023 2698947782 fixed submit issue
Sohel 09/24/2023 5155351299 Integrated Lookup and Fetch baseRepository API.
*/

import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet, httpDelete} from '../../../util/Rest';
import {DATA_REPOSITORY} from '../../../constants/MicroServiceConstants';
import download from '../../../util/DownloadLink';
import {fetchDownloadSuccessMsg} from '../PreviewFileData';
import {submissionEnd} from '../CommonActions/commonActions';
import {COMPANY, FIELD_USAGE} from '../../../constants/Lookup';
const initialData = {
  baseCategoryData: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  dataRepositoryData: {},
  getStatusCode: null,
  allRepositoryNames: [],
  usageData: [],
  DataRepoPrintStatus: null,
  dataRepoUsageStatus: null,
  dataRepoUsage: null,
  systemNotesStatus: null,
  notesuccessMsg: null,
  isSystemNoteLoading: null,
  configurationUrl: '',
  dockey: '',
  dropDownData: {},
  baseRepositoryData: [],
  baseRepositoryFieldsData: [],
};

const slice = createSlice({
  name: 'dataRepository',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
      state.fieldListStatus = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },

    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },

    getDataRepository: (state, action) => {
      state.dataRepositoryData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    fetchUsage: (state, action) => {
      state.usageData = action.payload;
      state.isLoading = false;
    },
    getRepositoryNames: (state, action) => {
      state.allRepositoryNames = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
    setDataRepositoryPrintData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.DataRepoPrintStatus = action.payload.status;
      state.successMsg = action.payload.message;
    },
    setDataRepoUsage: (state, action) => {
      state.dataRepoUsage = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.dataRepoUsageStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },

    postDataRepoSuccess: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.getStatusCode = action.payload.status;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.dataRepositoryData = null;
      state.getStatusCode = null;
      state.dataRepoUsage = [];
      state.dataRepoUsageStatus = null;
    },
    resetUsageData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.usageData = {};
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.notesuccessMsg = action.payload.message;
      state.isSystemNoteLoading = false;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    fetchBaseRepositoryData: (state, action) => {
      state.baseRepositoryData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    fetchBaseRepositoryFieldsData: (state, action) => {
      state.baseRepositoryFieldsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    resetNoteMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.systemNotesStatus = null;
      state.isSystemNoteLoading = false;
      state.notesuccessMsg = null;
    },
    resetDownloadMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.DataRepoPrintStatus = null;
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
    resetBaseRepositoryFieldsData: (state) => {
      state.baseRepositoryFieldsData = [];
    },
  },
});

export default slice.reducer;

export const {
  fetchStart,
  fetchError,
  fetchUsage,
  fetchSuccess,
  resetUsageData,
  resetMsg,
  setDataRepoUsage,
  setDataRepositoryPrintData,
  getDataRepository,
  postDataRepoSuccess,
  getRepositoryNames,
  postSystemNotesData,
  fetchNoteStart,
  resetNoteMessage,
  resetDownloadMessage,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
  fetchDropDownData,
  fetchBaseRepositoryData,
  fetchBaseRepositoryFieldsData,
  resetBaseRepositoryFieldsData,
} = slice.actions;

export const deleteRepository = (repositoryCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpDelete(`${DATA_REPOSITORY}/find/data-repository/${repositoryCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchDataRepository = (repositoryCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-repository/find/data-repository/${repositoryCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getDataRepository(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('lookup/find/all/lookup', {
      typeCode: [COMPANY, FIELD_USAGE],
    })
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDropDownData(data.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postDataRepository = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`data-repository/save/datarepodetails`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postDataRepoSuccess(data));
          // dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchBaseRepository = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-repository/find/all/repositoryNamesbycriteriafields`)
      .then((data) => {
        if (data && data?.status && data?.status === 200) {
          dispatch(fetchBaseRepositoryData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchBaseRepositoryFields = (dataRepositoryId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-repository/find/all/fieldsname/${dataRepositoryId}`)
      .then((data) => {
        if (data && data?.status && data?.status === 200) {
          dispatch(fetchBaseRepositoryFieldsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchDataRepoUsage = (payload, type) => {
  const Url =
    type === 'RepoField' ?
      `data-repository/usage/${payload?.dataRepositoryId}/${payload?.repositoryFieldId}` :
      `data-repository/usage/${payload}`;
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(Url)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(setDataRepoUsage(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchExistingDataRepositoryNames = (repositoryCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-repository/find/all/data-repository/code`)
      .then((data) => {
        if (data && data?.status && data?.status === 200) {
          dispatch(getRepositoryNames(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postRepoPrintUsage = (payload) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`framework/usage/print/frameworkusage`, payload)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          download(data.response);
          dispatch(fetchSuccess(data));
          dispatch(fetchUsage(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const printDataRepositories = (data, type) => {
  const url =
    type === 'repoNameTab' ?
      `data-repository/print/datarepositorydetails` :
      `data-repository/print/datarepository`;
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(url, data)
      .then((data) => {
        if (data && data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postPrintDataRepository({dockey: data?.response}, data));
          dispatch(setDockey(data?.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postPrintDataRepository = (payload, postRepoData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`data-repository/generateurlprintdr`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(setDataRepositoryPrintData(postRepoData));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccessMsg(postRepoData));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`data-repository/save/datarepositorynotes`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetDataRepo = (repositoryCode) => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetDownload = () => {
  return (dispatch) => {
    dispatch(resetDownloadMessage());
  };
};
export const resetPrintUsageData = () => {
  return (dispatch) => {
    dispatch(resetUsageData());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetNoteMessage());
  };
};
export const resetBaseRepositoryFields = () => {
  return (dispatch) => {
    dispatch(resetBaseRepositoryFieldsData());
  };
};
